/**
 * API queue (S5b) — wrapping autour de `apiClient`.
 *
 * Toutes les fonctions retournent des promesses typées sur `types/queue.ts`
 * (auto-générés depuis l'OpenAPI). Aucun mappeur BE↔FE.
 */

import { apiClient } from './client'
import type {
  EnqueueRequest,
  QueueItemDetailResponse,
  QueueItemResponse,
  QueueItemStatus,
  QueueListResponse,
  ReorderRequest,
} from '@/types/queue'

import type { components } from '@/types/api-generated'

type PlatformValue = components['schemas']['Platform']

export interface QueueListFilters {
  status?: QueueItemStatus
  platform?: PlatformValue
  workId?: number
  limit?: number
  offset?: number
}

export const queueApi = {
  list: async (filters: QueueListFilters = {}): Promise<QueueListResponse> => {
    const params: Record<string, string | number> = {}
    if (filters.status) params.status = filters.status
    if (filters.platform) params.platform = filters.platform
    if (filters.workId !== undefined) params.work_id = filters.workId
    if (filters.limit !== undefined) params.limit = filters.limit
    if (filters.offset !== undefined) params.offset = filters.offset
    const { data } = await apiClient.get<QueueListResponse>('/queue', { params })
    return data
  },

  detail: async (id: number): Promise<QueueItemDetailResponse> => {
    const { data } = await apiClient.get<QueueItemDetailResponse>(`/queue/${id}`)
    return data
  },

  enqueue: async (payload: EnqueueRequest): Promise<QueueItemResponse> => {
    const { data } = await apiClient.post<QueueItemResponse>('/queue/enqueue', payload)
    return data
  },

  pause: async (id: number): Promise<QueueItemResponse> => {
    const { data } = await apiClient.post<QueueItemResponse>(`/queue/${id}/pause`)
    return data
  },

  resume: async (id: number): Promise<QueueItemResponse> => {
    const { data } = await apiClient.post<QueueItemResponse>(`/queue/${id}/resume`)
    return data
  },

  forcePublishNow: async (id: number): Promise<QueueItemResponse> => {
    const { data } = await apiClient.post<QueueItemResponse>(`/queue/${id}/force-publish-now`)
    return data
  },

  reorder: async (id: number, payload: ReorderRequest): Promise<QueueItemResponse> => {
    const { data } = await apiClient.post<QueueItemResponse>(`/queue/${id}/reorder`, payload)
    return data
  },

  remove: async (id: number): Promise<void> => {
    await apiClient.delete(`/queue/${id}`)
  },
}

// Re-export pour confort d'import.
export type {
  EnqueueRequest,
  QueueItemDetailResponse,
  QueueItemResponse,
  QueueItemStatus,
  QueueListResponse,
  ReorderRequest,
}
